const sqlParser = require('../sqlparser/index');
const CommonUtil = require('../../../../utils/CommonUtil');
const g2 = require('../../../../g2');
const Extend = require('../../../../base/util/Extend');
const Parser = {};
/**
 * 解析语句
 * @param frag
 * @param value
 * @param nsObj
 * @returns {*}
 */
Parser.parseSqlFragment = function(frag, value, nsObj) {
    var commonChecker = function(fragment, value, nsObj) {
        if (CommonUtil.isArray(value)) {
            for (let i = 0; i < value.length; i++) {
                let item = value[i];
                if (item) {
                    var expr = item.expr;
                    if (expr && expr.table) {
                        if (!nsObj.hasOwnProperty(expr.table)) {
                            throw (new Error(fragment + '参数中字段【' + expr.column + '】的表别名【' + expr.table + '】错误！'));
                        }
                    }
                }
            }
        }
    }
    var whereChecker = function(fragment, value, nsObj) {
        if (value &&
            CommonUtil.isObject(value.left)) {
            doCheck(fragment, value, nsObj);
        } else {
            throw (new Error('错误的where格式！'));
        }

        function doCheck(fragment, value, nsObj) {
            if (value.hasOwnProperty('left')) {
                doCheck(fragment, value.left, nsObj);
                if (value.right &&
                    value.right.hasOwnProperty('left')) {
                    doCheck(fragment, value.right.left, nsObj);
                }
            } else {
                var table = value.table;
                if (table &&
                    (!nsObj.hasOwnProperty(table))) {
                    throw (new Error(fragment + '参数中字段【' + value.column + '】的表别名【' + table + '】错误！'));
                }
            }
        }
    }
    var fragments = {
        'select': {
            prefix: 'select ',
            suffix: ' from a',
            resultKey: 'columns',
            checker: commonChecker
        },
        'where': {
            prefix: 'select * from a where ',
            suffix: '',
            resultKey: 'where',
            checker: whereChecker
        },
        'sort': {
            prefix: 'select * from a where 1=1 order by ',
            suffix: '',
            resultKey: 'orderby',
            checker: commonChecker
        }
    }
    if (fragments.hasOwnProperty(frag)) {
        var obj = fragments[frag],
            warpValue = obj.prefix + value + obj.suffix;
        var parseResult;
        try {
            var parseObj = sqlParser.parse(warpValue);
            parseResult = parseObj[obj.resultKey];
        } catch (e) {
            throw (new Error(frag + '格式错误！'));
        }
        //检查
        obj.checker(frag, parseResult, nsObj || {});
        return parseResult;
    } else {
        throw (new Error("frag参数错误！"));
    }
}

/**
 *
 * @param obj
 * @returns {*}
 */
function getColumnKey(obj) {
    obj = obj || {};
    if (obj.table) {
        return obj.table + '.' + obj.column;
    } else {
        //todo 暂时支持一张图2.0服务
        return 'tag.' + obj.column;
        // return  obj.column;
    }
}

const helpers = {
    'AND': {
        'type': 'relation',
        'val': '$and'
    },
    'OR': {
        'type': 'relation',
        'val': '$or'
    },
    '=': {
        'fn': function(src, dest) {
            dest[getColumnKey(src.left)] = src.right.value;
        }
    },
    '>': {
        'fn': function(src, dest) {
            dest[getColumnKey(src.left)] = {
                '$gt': src.right.value
            };
        }
    },
    '>=': {
        'fn': function(src, dest) {
            dest[getColumnKey(src.left)] = {
                '$ge': src.right.value
            };
        }
    },
    '<': {
        'fn': function(src, dest) {
            dest[getColumnKey(src.left)] = {
                '$lt': src.right.value
            };
        }
    },
    '<=': {
        'fn': function(src, dest) {
            dest[getColumnKey(src.left)] = {
                '$le': src.right.value
            };
        }
    },
    '<>': {
        'fn': function(src, dest) {
            dest[getColumnKey(src.left)] = {
                '$nin': [src.right.value]
            };
        }
    },
    'IN': {
        'fn': function(src, dest) {
            var arr = [];
            for (let i = 0; i < src.right.value.length; i++) {
                let item = src.right.value[i];
                arr.push(item.value);
            }
            dest[getColumnKey(src.left)] = {
                '$in': arr
            };
        }
    },
    'NOT IN': {
        'fn': function(src, dest) {
            var arr = [];
            for (let i = 0; i < src.right.value.length; i++) {
                let item = src.right.value[i];
                arr.push(item.value);
            }
            dest[getColumnKey(src.left)] = {
                '$nin': arr
            };
        }
    },
    'LIKE': {
        'fn': function(src, dest) {
            var value = src.right.value.trim();
            value = '^' + value.replace(/%/g, '.*') + '$';
            dest[getColumnKey(src.left)] = {
                // '$regex': new RegExp(value)
                '$regex': value
            };
        }
    },
    'NOT LIKE': {
        'fn': function(src, dest) {
            var value = src.right.value.trim();
            value = '^' + value.replace(/%/g, '.*') + '$';
            dest[getColumnKey(src.left)] = {
                // '$not': new RegExp(value)
                '$regex': value
            };
        }
    },
    'BETWEEN': {
        'fn': function(src, dest) {
            var arr = [];
            for (let i = 0; i < src.right.value.length; i++) {
                let item = src.right.value[i];
                arr.push(item.value);
            }
            var and = [],
                column = getColumnKey(src.left);
            var floor = {},
                celling = {};
            floor[column] = {
                '$ge': arr[0]
            }
            celling[column] = {
                '$le': arr[1]
            }
            and.push(floor);
            and.push(celling);
            dest['$and'] = and;
        }
    }
}

const spatialRels = {
    'intersects': {
        'key': 'intersects',
        'map': '$geoIntersects'
    },
    'within': {
        'key': 'within',
        'map': '$geoWithin'
    },
    'near': {
        'key': 'near',
        'map': '$geoNear'
    }
}

/**
 * 减少关系语句层级
 * @param query
 * @returns {*}
 * @private
 */
function plainWhere(query) {
    var keys = ['$and', '$or'];
    var q = Extend(true, {}, query);
    while (plain(q)) {}
    return q;

    function plain(obj) {
        var flag = false;
        for (var i = 0; i < keys.length; i++) {
            var k = keys[i];
            if (obj.hasOwnProperty(k)) {
                var vals = obj[k],
                    newVals = [];
                for (var j = 0; j < vals.length; j++) {
                    var val = vals[j];
                    //删除空的and or
                    if (val.hasOwnProperty(keys[0]) &&
                        val[keys[0]].length == 0) {
                        delete val[keys[0]];
                        continue;
                    }
                    if (val.hasOwnProperty(keys[1]) &&
                        val[keys[1]].length == 0) {
                        delete val[keys[1]];
                        continue;
                    }
                    if (val.hasOwnProperty(k)) {
                        newVals = newVals.concat(val[k]);
                        flag = true;
                    } else {
                        newVals.push(val);
                    }
                }
                obj[k] = newVals;
                break;
            }
        }
        return flag;
    }
}

/**
 * 翻译where
 * @param where
 * @returns {{}}
 */
Parser.translateWhere = function(where) {
    var query = {};
    tran(where, query);
    query = plainWhere(query);
    return query;

    function tran(src, dest) {
        var helper = helpers[src.operator];
        if (helper.type === 'relation') {
            var mongoOperator = helper.val;
            var arr = [],
                leftObj = {},
                rightObj = {};
            tran(src.left, leftObj);
            tran(src.right, rightObj);
            if (Object.keys(leftObj).length > 0) {
                arr.push(leftObj);
            }
            if (Object.keys(rightObj).length > 0) {
                arr.push(rightObj);
            }
            dest[mongoOperator] = arr;
        } else {
            if (src.left.type == 'column_ref') {
                helper.fn(src, dest);
            }
        }
    }
}

//
Parser.translateSelect = function(select) {
    let list = [];
    for (let i = 0; i < select.length; i++) {
        let fieldName = select[i].expr.column;
        if (fieldName == 'geom') {
            list.push(fieldName);
        } else {
            //todo
            list.push("tag." + fieldName);
        }
    }
    return list.join(' ');
}

//sort-query
Parser.translateSort = function(sort) {
    let list = [];
    for (let i = 0; i < sort.length; i++) {
        let fieldName = sort[i].expr.column;
        let f = sort[i].type == 'ASC' ? '' : '-';
        list.push(f + "tag." + fieldName);
    }
    return list.join(' ');
}

//sort-aggregate
Parser.translateSortAggregate = function(sort) {
    let sortObj = {};
    for (let i = 0; i < sort.length; i++) {
        let fieldName = sort[i].expr.column;
        let sortVal = sort[i].type == 'ASC' ? 1 : -1;
        sortObj['tag.' + fieldName] = sortVal;
    }
    return sortObj;
}

//空间过滤条件
/** 
 * @param opts
 * @param opts.geometry
 * @param opts.inputSr
 * @param opts.dataSr
 * @param opts.spatialRel
 */
Parser.parseGeometryFilter = function(opts) {
    let filter = {},
        srRelation = {};
    let geometry = opts.geometry;
    //处理坐标系
    if (opts.inputSr != opts.dataSr) {
        let projectService = new g2.sfs.CoordinateTransform();
        let inputGeometry = g2.sfs.GeometryFactory.createGeometryFromGeoJson(opts.geomtry);
        inputGeometry.spatialReference = opts.inputSr;
        let geometryg2 = projectService.transform(inputGeometry, opts.dataSr);
        geometry = geometryg2.asGeoJson();
    }
    let spatialRel = spatialRels[opts.spatialRel];
    srRelation[spatialRel.map] = {
        '$geometry': geometry
    }
    filter['geom'] = srRelation;
    return filter;
}

module.exports = Parser;